import { Form, Formik } from "formik";
import React from "react";
import { useHistory } from "react-router-dom";

import { createUser, signInWithGoogle } from "../../auth/authImplementation";
import AddSpacing from "../../components/AddSpacing";

import Authentication from "./Authentication";
import {
  AuthInputRow,
  AuthTitle,
  error,
  GoogleSignInButton,
  Line,
  RedirectLink,
  SignInButton,
} from "./SharedComponent";

const makeObjectOfEmptyString = (...propertyList) => {
  const obj = {};
  propertyList.forEach((prop) => (obj[prop] = ""));
  return obj;
};

const SignUpPage = () => {
  const history = useHistory();

  const submit = async (object) => {
    try {
      await createUser(object);
      history.push("/");
    } catch (e) {
      error(e.message);
    }
  };

  const GoogleLogIn = async () => {
    try {
      await signInWithGoogle();
      history.push("/");
    } catch (e) {
      error(e.message);
    }
  };

  return (
    <Authentication>
      <AuthTitle>Sign Up to Copysmith</AuthTitle>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <GoogleSignInButton onClick={GoogleLogIn} />
      </div>
      <Line />
      <Formik
        initialValues={makeObjectOfEmptyString(
          "fullName",
          "companyName",
          "email",
          "password",
          "accessCode"
        )}
        onSubmit={submit}
      >
        {({ handleChange, handleBlur, handleSubmit }) => {
          const generatePropObject = (name) => ({
            name,
            onChange: handleChange,
            onBlur: handleBlur,
          });
          const generatePropObjects = (...names) =>
            names.length > 1
              ? names.map(generatePropObject)
              : generatePropObject(names);
          return (
            <Form>
              <AddSpacing spacing={20}>
                <AuthInputRow
                  titles={["Full Name", "Company Name"]}
                  propObjects={generatePropObjects(
                    "displayName",
                    "companyName"
                  )}
                />
                <AuthInputRow
                  types="email"
                  titles="Email Address"
                  propObjects={generatePropObjects("email")}
                />
                <AuthInputRow
                  types="password"
                  titles="Password"
                  propObjects={generatePropObjects("password")}
                />
                {/* <CheckboxObject/> */}
                <SignInButton onClick={handleSubmit}>
                  Create Account
                </SignInButton>
              </AddSpacing>
            </Form>
          );
        }}
      </Formik>
      <RedirectLink link="/login" name="Already a member?" linkName="Log in" />
    </Authentication>
  );
};

export default SignUpPage;
